module.exports = __webpack_public_path__ + "static/img/askBanner.ba08478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/askBanner.png
// module id = uOxS
// module chunks = 1